import React from "react";
import {
  Container,
  Typography,
  Box,
  List,
  ListItem,
  ListItemText,
  Divider,
} from "@mui/material";
import SimpleHeader from "../components/SimpleHeader";

const PrivacyPolicy = () => {
  return (
    <>
      <SimpleHeader />
      <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
        <Typography variant="h4" gutterBottom>
          Privacy Policy
        </Typography>
        <Typography variant="body1" paragraph>
          Your privacy is important to ASQI Investment Managers Private Limited
          (“Company” or “we” or “us”). This Privacy Policy explains how we
          collect, use, and safeguard the information you provide to us through
          or in association with FarmApp (the “App”), its related features and
          functions, and other services provided by the Company. Please read
          this policy carefully to understand how we handle your information.
        </Typography>
        <Typography variant="body1" paragraph>
          By using the FarmApp, you agree to the terms of this Privacy Policy.
          If you do not agree with the terms, please do not use or access the
          App.
        </Typography>

        <Divider sx={{ my: 2 }} />

        <Typography variant="h5" gutterBottom>
          Types of Information We Collect
        </Typography>
        <List>
          <ListItem>
            <ListItemText
              primary="Personally Identifiable Information (PII)"
              secondary="This includes any information that can identify you as an individual, such as your name, contact information, email address, phone number, geographic location, agricultural details, and payment details."
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primary="Aggregate Information"
              secondary="This includes anonymous data such as device information, IP address, browsing behavior, and usage patterns to help improve the App."
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primary="Information from Third Parties"
              secondary="We may receive information about you from partners, service providers, or other organizations you engage with for agricultural activities."
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primary="Recording Communications"
              secondary="We may monitor or record communications between you and us for verification, improving services, or resolving disputes."
            />
          </ListItem>
        </List>

        <Divider sx={{ my: 2 }} />

        <Typography variant="h5" gutterBottom>
          What We Do With the Information
        </Typography>
        <List>
          <ListItem>
            <ListItemText
              primary="Improving Our Services"
              secondary="Using Aggregate Information to troubleshoot technical issues and enhance the App's functionality."
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primary="Providing Personalized Services"
              secondary="Using PII to deliver tailored services like agricultural recommendations, crop management tips, and market linkages."
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primary="Marketing and Promotions"
              secondary="Using PII for marketing and promotional purposes, including updates about new features and offers."
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primary="Sharing Information"
              secondary="We may share your PII with business partners, service providers, or governmental authorities as required by law."
            />
          </ListItem>
        </List>

        <Divider sx={{ my: 2 }} />

        <Typography variant="h5" gutterBottom>
          Security Measures
        </Typography>
        <Typography variant="body1" paragraph>
          We take appropriate measures to safeguard your Personally Identifiable
          Information using industry-standard encryption methods, including
          Secure Sockets Layer (SSL) technology. However, no data transmission
          over the internet is 100% secure, and you acknowledge that you share
          your information at your own risk.
        </Typography>

        <Divider sx={{ my: 2 }} />

        <Typography variant="h5" gutterBottom>
          Cookies
        </Typography>
        <Typography variant="body1" paragraph>
          The App uses cookies and similar technologies to enhance the user
          experience. Cookies help us remember your preferences, track your
          usage patterns, and provide customized content. You can manage your
          cookie preferences through your device settings.
        </Typography>

        <Divider sx={{ my: 2 }} />

        <Typography variant="h5" gutterBottom>
          Third-Party Links
        </Typography>
        <Typography variant="body1" paragraph>
          FarmApp may contain links to third-party websites or services that are
          not controlled by the Company. We encourage you to review the privacy
          policies of any external websites before providing personal
          information.
        </Typography>

        <Divider sx={{ my: 2 }} />

        <Typography variant="h5" gutterBottom>
          Deleting Your Information
        </Typography>
        <Typography variant="body1" paragraph>
          If you no longer wish to receive communications from us or would like
          us to delete your Personally Identifiable Information, you can contact
          us at connect@asqi.in. We will honor your request in accordance with
          our internal procedures and legal obligations.
        </Typography>

        <Divider sx={{ my: 2 }} />

        <Typography variant="h5" gutterBottom>
          Changes to This Privacy Policy
        </Typography>
        <Typography variant="body1" paragraph>
          If we make changes to this Privacy Policy, we will notify you through
          the App or by posting an updated policy on our website. Please review
          this policy periodically for any updates.
        </Typography>

        <Divider sx={{ my: 2 }} />

        <Typography variant="h5" gutterBottom>
          Grievance Officer
        </Typography>
        <Typography variant="body1" paragraph>
          The contact details of our Grievance Officer are as follows:
        </Typography>
        <Box sx={{ pl: 2 }}>
          <Typography variant="body1">Ms. Sonia Kapoor</Typography>
          <Typography variant="body1">
            Company Name: ASQI Investment Managers Private Limited
          </Typography>
          <Typography variant="body1">
            Address: H-532, Kanakia Zillion, BKC Annexe, Kurla West, Mumbai
            400070
          </Typography>
          <Typography variant="body1">Email: connect@asqi.in</Typography>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Typography variant="body1" paragraph>
          This Privacy Policy ensures that the information of FarmApp users is
          handled responsibly and securely.
        </Typography>
      </Container>
    </>
  );
};

export default PrivacyPolicy;
